/**
 * VyV BackOffice API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParameterCodec,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { Observable } from "rxjs";
import { CustomHttpParameterCodec } from "../encoder";

// @ts-ignore
import { LessorVm } from "../model/lessorVm";

// @ts-ignore
import { environment } from "src/environments/environment";
import { Configuration } from "../configuration";
import { BASE_PATH } from "../variables";

@Injectable({
  providedIn: "root",
})
export class LessorsService {
  protected basePath = environment.apiV2RootUrl;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string,
  ): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string,
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substring(0, 10),
          );
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * @param address
   * @param zipCode
   * @param city
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsBySolidarityAddressGet(
    address: string,
    zipCode: string,
    city: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<LessorVm>;
  public apiLessorsBySolidarityAddressGet(
    address: string,
    zipCode: string,
    city: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<LessorVm>>;
  public apiLessorsBySolidarityAddressGet(
    address: string,
    zipCode: string,
    city: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<LessorVm>>;
  public apiLessorsBySolidarityAddressGet(
    address: string,
    zipCode: string,
    city: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (address === null || address === undefined) {
      throw new Error(
        "Required parameter address was null or undefined when calling apiLessorsBySolidarityAddressGet.",
      );
    }
    if (zipCode === null || zipCode === undefined) {
      throw new Error(
        "Required parameter zipCode was null or undefined when calling apiLessorsBySolidarityAddressGet.",
      );
    }
    if (city === null || city === undefined) {
      throw new Error(
        "Required parameter city was null or undefined when calling apiLessorsBySolidarityAddressGet.",
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (address !== undefined && address !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>address,
        "address",
      );
    }
    if (zipCode !== undefined && zipCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>zipCode,
        "zipCode",
      );
    }
    if (city !== undefined && city !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>city,
        "city",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (Bearer) required
    const localVarCredential: string | undefined =
      this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors/bySolidarityAddress`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<LessorVm>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param productCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsGet(
    productCode: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<LessorVm>>;
  public apiLessorsGet(
    productCode: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<LessorVm>>>;
  public apiLessorsGet(
    productCode: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<LessorVm>>>;
  public apiLessorsGet(
    productCode: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (productCode === null || productCode === undefined) {
      throw new Error(
        "Required parameter productCode was null or undefined when calling apiLessorsGet.",
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (productCode !== undefined && productCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>productCode,
        "productCode",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<Array<LessorVm>>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param lessorId
   * @param zipCode
   * @param city
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsLessorIdAddressesGet(
    lessorId: number,
    zipCode: string,
    city: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any>;
  public apiLessorsLessorIdAddressesGet(
    lessorId: number,
    zipCode: string,
    city: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<any>>;
  public apiLessorsLessorIdAddressesGet(
    lessorId: number,
    zipCode: string,
    city: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<any>>;
  public apiLessorsLessorIdAddressesGet(
    lessorId: number,
    zipCode: string,
    city: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (lessorId === null || lessorId === undefined) {
      throw new Error(
        "Required parameter lessorId was null or undefined when calling apiLessorsLessorIdAddressesGet.",
      );
    }
    if (zipCode === null || zipCode === undefined) {
      throw new Error(
        "Required parameter zipCode was null or undefined when calling apiLessorsLessorIdAddressesGet.",
      );
    }
    if (city === null || city === undefined) {
      throw new Error(
        "Required parameter city was null or undefined when calling apiLessorsLessorIdAddressesGet.",
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (zipCode !== undefined && zipCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>zipCode,
        "zipCode",
      );
    }
    if (city !== undefined && city !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>city,
        "city",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors/${this.configuration.encodeParam({ name: "lessorId", value: lessorId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32" })}/addresses`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<any>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param lessorId
   * @param zipCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsLessorIdCitiesGet(
    lessorId: number,
    zipCode: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any>;
  public apiLessorsLessorIdCitiesGet(
    lessorId: number,
    zipCode: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<any>>;
  public apiLessorsLessorIdCitiesGet(
    lessorId: number,
    zipCode: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<any>>;
  public apiLessorsLessorIdCitiesGet(
    lessorId: number,
    zipCode: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (lessorId === null || lessorId === undefined) {
      throw new Error(
        "Required parameter lessorId was null or undefined when calling apiLessorsLessorIdCitiesGet.",
      );
    }
    if (zipCode === null || zipCode === undefined) {
      throw new Error(
        "Required parameter zipCode was null or undefined when calling apiLessorsLessorIdCitiesGet.",
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (zipCode !== undefined && zipCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>zipCode,
        "zipCode",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors/${this.configuration.encodeParam({ name: "lessorId", value: lessorId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32" })}/cities`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<any>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param lessorId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsLessorIdZipCodeGet(
    lessorId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any>;
  public apiLessorsLessorIdZipCodeGet(
    lessorId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<any>>;
  public apiLessorsLessorIdZipCodeGet(
    lessorId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<any>>;
  public apiLessorsLessorIdZipCodeGet(
    lessorId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (lessorId === null || lessorId === undefined) {
      throw new Error(
        "Required parameter lessorId was null or undefined when calling apiLessorsLessorIdZipCodeGet.",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors/${this.configuration.encodeParam({ name: "lessorId", value: lessorId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32" })}/zipCode`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<any>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param lessorName
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsLessorNameEmailGet(
    lessorName: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any>;
  public apiLessorsLessorNameEmailGet(
    lessorName: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<any>>;
  public apiLessorsLessorNameEmailGet(
    lessorName: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<any>>;
  public apiLessorsLessorNameEmailGet(
    lessorName: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (lessorName === null || lessorName === undefined) {
      throw new Error(
        "Required parameter lessorName was null or undefined when calling apiLessorsLessorNameEmailGet.",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/api/lessors/${this.configuration.encodeParam({ name: "lessorName", value: lessorName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}/email`;
    localVarPath = localVarPath.replace("/api", "");
    return this.httpClient.request<any>(
      "get",
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param productCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiLessorsGetWithZipCode(
    zipCode: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<LessorVm>>;
  public apiLessorsGetWithZipCode(
    zipCode: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<LessorVm>>>;
  public apiLessorsGetWithZipCode(
    zipCode: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<LessorVm>>>;
  public apiLessorsGetWithZipCode(
    zipCode: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (zipCode === null || zipCode === undefined) {
      throw new Error(
        "Required parameter zipCode was null or undefined when calling apiLessorsGetWithZipCode.",
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential("Bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        "Authorization",
        localVarCredential,
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected,
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/lessors`;
    return this.httpClient.request<Array<LessorVm>>(
      "get",
      `${this.configuration.basePath}${localVarPath}/${zipCode}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }
}
